module.exports = __webpack_public_path__ + "static/media/i5.60026965.jpg";